import {createApp} from 'vue'
import {createPinia} from "pinia";
import App from './App.vue'

import axios from 'axios'
import {createRouter, createWebHashHistory} from 'vue-router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import AltarServers from "@/components/AltarServers";
import Absences from "@/components/Absences";
import Masses from "@/components/Masses";
import Schedules from "@/components/Schedules";
import ScheduleDetail from "@/components/ScheduleDetail";
import ScheduleStatistics from "@/components/ScheduleStatistics.vue";
import ScheduleAnnotations from "@/components/ScheduleAnnotations.vue";
import Media from "@/components/Media.vue";
import Authentication from "@/components/Authentication.vue";
import {useAuthenticationStore} from "@/stores/authentication";
import {useNetworkStore} from "@/stores/network";
import MassKaPlanImport from "@/components/MassKaPlanImport.vue";
import EmailSend from "@/components/EmailSend.vue";
import AdminShell from "@/components/AdminShell.vue";
import PublicShell from "@/components/PublicShell.vue";
import SelfServiceAbsences from "@/components/SelfServiceAbsences.vue";
import SelfServiceWindowSettings from "@/components/SelfServiceWindowSettings.vue";

const routes = [
    {
        path: '/',
        component: PublicShell,
        children: [
            {
                path: '',
                name: 'SelfService',
                component: SelfServiceAbsences
            }
        ]
    },
    {
        path: '/admin',
        component: AdminShell,
        children: [
            {
                path: '',
                name: 'Messdiener',
                component: AltarServers
            },
            {
                path: 'abmeldungen',
                name: 'Abmeldungen',
                component: Absences
            },
            {
                path: 'messen',
                name: 'Messen',
                component: Masses
            },
            {
                path: 'messen-import',
                name: 'Messen Import',
                component: MassKaPlanImport
            },
            {
                path: 'plaene',
                name: 'Plaene',
                component: Schedules
            },
            {
                path: 'plaene/:id',
                name: 'Plan',
                component: ScheduleDetail
            },
            {
                path: 'plaene/:id/statistik',
                name: 'PlanStatistik',
                component: ScheduleStatistics
            },
            {
                path: 'plaene/:id/plananmerkungen',
                name: 'PlanAnmerkungen',
                component: ScheduleAnnotations
            },
            {
                path: 'media',
                name: 'Medien',
                component: Media
            },
            {
                path: 'authentication',
                name: 'Authentication',
                component: Authentication
            },
            {
                path: 'email',
                name: 'EmailSend',
                component: EmailSend
            },
            {
                path: 'einstellungen',
                name: 'Einstellungen',
                component: SelfServiceWindowSettings
            }
        ]
    }
]

// Create router object
const router = createRouter({
    history: createWebHashHistory(),
    routes,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'
})

// Create Axios object
const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true,
})

// Append CSRF tokens to all request
client.interceptors.request.use(function (config) {
    const csrfToken = useAuthenticationStore().csrfToken;
    config.headers['X-CSRFToken'] = csrfToken || '';
    return config;
})


// Add axios object to pinia stores
const pinia = createPinia().use(({store}) => {
    store.axios = client;
});

const app = createApp(App);
app.config.globalProperties.axios = client;
app.use(router).use(pinia)

const networkStore = useNetworkStore();

// Add interceptor to detect when user is offline
client.interceptors.response.use(response => {
    networkStore.online = true;
    return response;
}, error => {
    // Either request sent but no response, or error code "ERR_NETWORK", or HTTP server error status code
    networkStore.online = !((error.request && !error.response) || error.code === "ERR_NETWORK" || (error.response && error.response.status >= 500));
    return Promise.reject(error);
})

app.mount('#app')
